import type { ReactNode } from 'react';

import { Link } from '@tanstack/react-router';

import { NessoLogo } from '@nesso/ui/icons/nesso-logo';

type Props = {
    /** Replaces the logo — settings swaps in a "Back to Workspace" link. */
    leading?: ReactNode;
    actions?: ReactNode;
    dropdown?: ReactNode;
    banner?: ReactNode;
    mobileBanner?: ReactNode;
    disableLogoNavigation?: boolean;
};

export function NavigationBar({
    leading,
    actions,
    dropdown,
    banner,
    mobileBanner,
    disableLogoNavigation,
}: Props) {
    return (
        <>
            <div className="w-full h-16 py-4 px-2 shrink-0 bg-background border-b border-base-border flex justify-between items-center overflow-hidden">
                {leading ??
                    (disableLogoNavigation ? (
                        <NessoLogo />
                    ) : (
                        <Link to="/dashboard" aria-label="Go to dashboard">
                            <NessoLogo />
                        </Link>
                    ))}
                <div className="flex items-center gap-3">
                    {actions}
                    {banner}
                    {dropdown}
                </div>
            </div>
            {mobileBanner}
        </>
    );
}
